var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCactus = function SvgCactus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 114 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cactus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.682 160.574 2.817 5.169 25.014 10.113 44.62-10.113V83.489h-6.648l-5.296 6.405-4.394 1.798-2.14 6.18v6.967h-7.1l-3.267 5.618-6.423 1.012-3.38-2.81-9.127 1.798-10.028 8.203-1.352 7.529-6.874 4.607-4.706 3.065-1.716 5.475 4.957 2.922v9.214l-4.957 4.382v4.72Z",
    fill: "#605425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.398 133.861-1.716 5.475 3.433 4.586h4.636l2.747-4.586 9.614-5.475 4.246-5.905 3.824-5.666h5.303l9.803-2.747h4.638l2.575-.883 6.696-1.006 4.635-8.995v-3.82l3.653-2.98 6.648-10.167v-8.203h-6.648l-5.296 6.405-4.394 1.798-2.14 6.18v6.967h-7.1l-3.267 5.618-6.423 1.012-3.38-2.81-9.127 1.798-10.028 8.203-1.352 7.529-6.874 4.607-4.706 3.065Z",
    fill: "#B19D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.458 128.39v6.869l-8.395 2.136-6.868 1.679 1.221-10.684 9.463-5.953 7.785-1.221-3.206 7.174Z",
    fill: "#95853C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.458 128.39v6.869l-8.395 2.136-6.868 1.679 10.684-4.579 1.069-1.373v-3.511l1.831-2.289 1.68-2.595 3.205-3.511-3.206 7.174Z",
    fill: "#605425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.88 122.437 7.784-1.221-3.358 2.29-3.053.763-3.51 1.679-2.748 2.442c-.356.661-1.099 2.045-1.221 2.29-.153.305.458 2.747 0 3.052-.458.305-.61 6.258-.916 6.258-.305 0-3.205 1.221-3.205.611 0-.489-.305-2.849-.458-3.969l1.221-8.242 9.463-5.953Z",
    fill: "#FAF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m49.545 139.676 5.037-11.905-1.406-.595-5.037 11.906 1.406.594Z",
    fill: "#B19D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.831 125.642-1.068 15.416-10.379 4.274H6.868l-1.374-20.453-4.426-12.516 3.205-13.431-1.831-11.448L0 79.7l7.937 4.884 3.052 8.853 8.395 6.41 1.069 7.632-2.443 3.663 1.374 5.648 11.447 8.852Z",
    fill: "#95853C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.831 125.642-1.068 15.416-10.379 4.274H6.868l9.616-1.374 6.258-1.984.61-1.832v-8.089l-1.984-5.342-4.884-4.427-2.595-5.494.458-6.106 2.137-5.495v-3.205l-5.495-5.495-3.052-2.594V88.4l-3.511-4.732L0 79.7l7.937 4.884 3.052 8.853 8.395 6.41 1.069 7.632-2.443 3.663 1.374 5.648 11.447 8.852Z",
    fill: "#605425"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M2.442 87.484 0 79.7c.61 1.322 1.954 3.999 2.442 4.12.488.123 2.239 1.375 3.053 1.985.152.814.366 2.686 0 3.663-.367.977.356 3.46.763 4.58v1.983c-.051.967-.214 2.992-.458 3.358-.244.367.203 3.206.458 4.579l-1.984 4.121v3.053l1.984 6.716 2.595 4.121 1.526 6.258-.305 5.495 1.831 7.174v5.8l-5.037-1.374-1.373-20.453-4.427-12.516 3.206-13.431-1.832-11.448Z",
    fill: "#FAF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.782 97.084-1.385.642 3.898 8.395v4.612l-1.27 4.601.122.256c.977 2.057 2.982 6.33 3.333 7.267.2.535 1.001 2.185 1.886 3.967a555.081 555.081 0 0 0 2.53 5.029l2.727 12.572 1.491-.324-2.768-12.765-.045-.088a568.66 568.66 0 0 1-2.568-5.102c-.907-1.827-1.658-3.383-1.824-3.825-.365-.974-2.263-5.023-3.261-7.129l1.173-4.252v-5.156l-4.04-8.7Z",
    fill: "#B19D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.095 128.237-.763 8.242-7.327 7.632-11.6 1.221 1.527-13.89 2.9-11.6-4.427-4.884v-7.174l3.053-12.058 4.121 8.395 3.205 4.732 2.29 6.105 9.768 6.716-2.747 6.563Z",
    fill: "#B19D44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.095 128.237-.763 8.242-4.884 7.632 1.068-8.548v-8.852l1.221-4.122-.916-2.747-3.816-3.053-3.358-3.968-1.068-4.884-4.121-3.206v-9.005l4.121 8.395 3.205 4.732 2.29 6.105 9.768 6.716-2.747 6.563Z",
    fill: "#605425"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "m26.405 107.784 3.053-12.058v3.816l-.763 4.884-.763 4.274v3.663L29 114.958c.865.865 2.595 2.656 2.595 2.9 0 .244.814 2.442 1.22 3.51l-1.22 3.206-2.137 5.647.458 4.121-.458 8.09-3.053 2.9 1.527-13.89 2.9-11.6-4.427-4.884v-7.174Z",
    fill: "#FAF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m33.964 115.042-1.479-5.621-1.476.389 1.574 5.98 5.666 6.262-1.77 8.703v10.608h1.526v-10.455l1.893-9.308-5.934-6.558Z",
    fill: "#95853C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.604 119.271-.842 28.689-17.394-.562v-28.69l-1.262-11.251-13.186-1.898-10.38-5.837-4.068-12.797-2.946-26.721 17.394 2.953v11.954l2.946 14.345 13.326.984-.842-12.516-.982-17.72-.56-17.72L67.3.856h9.68l14.307 7.876v21.517l-.28 13.641-.28 15.61.56 17.44 10.381-1.829 12.204-29.674V81.44l-6.874 9-15.71 2.11-1.684 26.721Z",
    fill: "#7A6A2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.604 119.27-.842 28.69H72.333l1.852-14.288 3.572-11.641 2.778-13.89V98.087l2.91-12.038 2.778-18.388V11.57l5.064-2.84v21.517l-.28 13.642-.28 15.61.56 17.439 10.381-1.828 12.204-29.674v36.002l-6.874 9-15.71 2.11-1.684 26.721Z",
    fill: "#49401D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.472 86.924-2.946-26.72 7.014 4.282v23.68l5.024 7.672 5.356 5.689 5.888 1.058 7.298 4.872-13.186-1.899-10.38-5.836-4.068-12.798Z",
    fill: "#B19D44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m42.472 86.924-2.946-26.72 2.249 1.769V70.439l1.19 6.218v4.762l1.323 5.505v1.77L45.48 92.4l2.117 5.688 2.513 2.249 4.63 2.778 2.181 2.444-10.38-5.836-4.068-12.798Z",
    fill: "#FAF8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3.856h9.68l2.497 27.913v19.71l-1.059 17.86v16.8l-1.439 5.953-3.787 1.348-.842-12.516-.982-17.72-.561-17.72L67.3.856Z",
    fill: "#B19D44"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m67.3.856 2.536.265 2.233 27.648 1.587 19.71.794 17.86v16.8l.148 5.953-1.406 1.348-.842-12.516-.982-17.72-.56-17.72L67.3.856Z",
    fill: "#FAF8F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cactus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .856h114v133a6 6 0 0 1-6 6H0v-139Z",
    fill: "#fff"
  })))));
};

export default SvgCactus;